module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov12-f14d2436dd31077216b296afb019f135.jpg";